import BrowseInfluencerDetail from '@/Component/Brand/BrowseInfluencer/BrowseInfluencerDetail'

const BrowseInfluencerDetailPage = () => {
    return (
        <BrowseInfluencerDetail />
    )
}

export default BrowseInfluencerDetailPage
